module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAMBAMAAAA3/zYzAAAAG1BMVEUAAADDpl/Dpl/Dpl/Dpl/Dpl/Dpl/Dpl/Dpl8K7huxAAAACHRSTlMAmYNLEs3DCPfb+NgAAABNSURBVBjTY2BgYFJgYGBnIAQ0mhgYnAwIKGLq6FBgURQmZFRHR5OToKABAaOAIFFQUJiAUUDQKgg3jLAqQVwAYSPlrkeEBOWhSlwMAQD4Qhd0ooqa9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/goldLeft .png
// module id = mhnA
// module chunks = 1